var parameterInsert={ 
    IdDocType:'',
    IdEnterprise:'',
    Name:'',  
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdDocCategory:'', 
    Name:'',  
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={ 
    IdDocType:'0',
    Name:'',      
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}